<template>
    <div class="banners">
        <swiper :options="swiperOption">
            <swiper-slide><banner-horses /></swiper-slide>
            <swiper-slide><banner-games /></swiper-slide>
            <swiper-slide><banner-roulette /></swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
    </div>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import BannerHorses from './banners/horses.vue'
    import BannerGames from './banners/games.vue'
    import BannerRoulette from './banners/roulette.vue'

    export default {
        name: 'Banners',
        components: { swiper, swiperSlide, BannerHorses, BannerGames, BannerRoulette },
        data() {
            return {
                swiperOption: {
                    loop: true,
                    autoplay: {
                        delay: 10000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        },
         methods:{
           
        }
    }
</script>

<style lang="scss">
    .banners {
        position: relative;
        background: $dark;
        min-height: 640px;

        .banner {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;

            .inner {
                position: absolute;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                color: $white;
            }

            .avideo {
                position: absolute;
                width: 100%;
                height: 100%;
                overflow: hidden;
            }

            video {
                position: absolute;
                top: 50%;
                left: 50%;
                width: auto;
                min-width: 100%;
                height: auto;
                object-fit: cover;
                transform: translate(-50%, -50%);
            }

            .limage img {
                width: auto;
                min-width: 100%;
                height: 100%;
            }
        }


        .swiper-container {
            position: relative;
            width: 100%;
            height: 100%;


            &.swiper-container-horizontal {
                >.swiper-pagination-bullets {
                    position: absolute;
                    display: flex;
                    width: auto;
                    transform: translateX(-50%);
                    left: 50%;
                    padding: $spacer*2;
                    border-top-left-radius: $spacer*2;
                    border-top-right-radius: $spacer*2;
                    background: rgba($black,0.7);

                    > .swiper-pagination-bullet {
                        margin: $spacer/2 !important;
                        border: 3px solid $white !important;

                        &.swiper-pagination-bullet-active {
                            border: 6px solid $primary !important;
                        }
                    }
                }

                > .swiper-button-prev,
                > .swiper-button-next {
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    top: 50%;
                    height: 150px;
                    width: auto;
                    padding: $spacer*2;
                    background: rgba($black,0.7) !important;
                    transform: translateY(-50%);
                    color: $white;
                }

                > .swiper-button-prev {
                    border-top-right-radius: $spacer*2;
                    border-bottom-right-radius: $spacer*2;
                }

                > .swiper-button-next {
                    border-top-left-radius: $spacer*2;
                    border-bottom-left-radius: $spacer*2;
                }
            }
        }

        .swiper-wrapper {
            height: 100%;
        }

    
        @media (max-width: ($desktop)-1) {
            .swiper-pagination-bullets {
                background: transparent !important;
            }

            .swiper-button-prev,
            .swiper-button-next {
                display: none !important;
            }
        }

    @media (max-width: ($tablet)-1) and (orientation: portrait) {
            .title {
                font-size: 0.7rem !important;
            }

        .text {
            font-size: 3rem !important;
        }

        .button-lg {
            height: 60px;
            line-height: 60px;
            border-radius: 30px;
            font-size: 16px;
        }
    }

    @media (max-width: ($tablet)-1) and (orientation: landscape) {
        min-height: 360px;
        height: 100vh;

        .title {
            font-size: 0.5rem !important;
        }

        .text {
            font-size: 2.5rem !important;
        }

        .button-lg {
            height: 60px;
            line-height: 60px;
            border-radius: 30px;
            font-size: 16px;
        }
    }
}
</style>
